/** @format */

import { KillSwitches } from '@shared/data-access/interfaces';

const killSwitchProd: KillSwitches = {
	// please keep in alpha order
	availabilityOnProductCardsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	boplExperienceEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	browseBreadcrumbsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	certonaQuickviewEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	crossChainBopis: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	enableTooltipSurvey: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	favoritesEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	isBotCheckEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	isServerSideRenderStateDataEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isPLPMLIntegrationEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isPLPServerSideRenderEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isPLPRedisEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isSRLPRedisEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	listsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	newEATApiEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	viewMoreEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	removeVerticalTextEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isPartyAttributesEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	sameDayDeliveryEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	sortPositionChangeEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	shopAllCategoryBubbleEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	showPinnedProducts: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	showPinnedContent: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	skuFavoritesEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	useNewPricingService: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	useQVProductTemplate: {
		dsg: false,
		gg: false,
		pl: true,
		g3: true
	},
	isPLPProTipsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	plpGoogleAdManagerEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	showNewSponsoredLabel: {
		dsg: false,
		gg: true,
		pl: false,
		g3: false
	},
	showPLPSponsoredProducts: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	plpSearchResultSurveyEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: true
	},
	plpShowCustomerRating: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	triggerSponsoredProductsIntendedEvent: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	triggerSponsoredProductsShownEvent: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	usePerformancePageSize: {
		dsg: false,
		gg: false,
		pl: false,
		g3: true
	},
	compareCheckboxEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	compareGridEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	//for enabling images swatches
	useImageSwatches: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isUsingCriteoSPAAdServer: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	}
};

export default killSwitchProd;
